"use client"
import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Col, Container, Row} from 'react-bootstrap';
import {hardGray, hover, softWhite, text, white} from '@/styles/globalStyleVars';
import SocialShare from "@/components/common/SocialShare";
import {usePathname} from "next/navigation";
import {Img} from "@/components/common/ui/Img";
import VideoDetails from "@/components/details/VideoDetails";
import {gsap} from "gsap";
import useDeviceTypeTab from "@/components/hooks/useDeviceTypeTab";
import Button from "@/components/common/ui/Button";
import reactHtmlParser from "react-html-parser";
import {useShowSetting} from "@/app/ShowSettingProvider";
import KeyPopUPBannerSlider from "@/components/common/forms/KeyPopUPBannerSlider";
import DetailSlider from "@/components/details/DetailSlider";

const Details = ({data}) => {

    const detailsRef = useRef();
    const showSetting = useShowSetting();

    const location = usePathname();

    // const logo = data?.images?.list?.find(f => f?.thumb === 'on');
    // const banner = data?.images?.list?.find(f => f?.banner === 'on');


    const leftWrapperRef = useRef(null);
    useEffect(() => {
        const col4Element = document.querySelector('.social-pin-wrapper');
        const rightWrapperElement = document.querySelector('.details__right');
        let scrollTriggerInstance;

        if (window.innerWidth >= 768 && col4Element && rightWrapperElement) {
            scrollTriggerInstance = gsap.to(col4Element, {
                scrollTrigger: {
                    trigger: col4Element,
                    start: 'top +160',
                    end: () => `+=${rightWrapperElement.scrollHeight - 100}`,
                    pin: true,
                    pinSpacing: false
                }
            });
        }

        // Cleanup function
        return () => {
            if (scrollTriggerInstance) {
                scrollTriggerInstance.scrollTrigger?.kill();  // Kill the ScrollTrigger instance
                gsap.killTweensOf(col4Element);  // Kill any tweens associated with the element
            }
        };
    }, [data]);

    const isMobile = useDeviceTypeTab();

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);


    };
    let bannerImage;

    try {
        bannerImage = data?.images?.list?.find((f) => f?.banner === 'on') || null;
    } catch (error) {
        console.error("Error finding banner image:", error);
        bannerImage = null;
    }
    const sectionList = data?.posts?.list

    return (
        <StyledDetails className="details-wrapper">
            <KeyPopUPBannerSlider lefttitle={showSetting?.data?.course_modal_title} subtitle={showSetting?.data?.course_modal_subtitle} courseName={data?.data?.title} show={show} handleClose={handleClose}/>

            <Container>
                <Row ref={detailsRef}>
                    {
                        isMobile ?
                            <Col md={12} className={'forMobile'}>
                                <div ref={leftWrapperRef} className="mobilefooter ">
                                    <SocialShare/>
                                    <Button href={'javascript:void(0)'} onClick={handleShow} text={'Apply with Maximus'} margin={'20px 0 0'} border={'1px solid'} width={'100%'} borderColor={text} background={'transparent'} color={text} hoverBackground={hover} hoverColor={white}/>

                                </div>
                            </Col>
                            : ''
                    }
                    <Col md={{span: 3}} >
                        <div ref={leftWrapperRef} className="social-pin-wrapper ">
                            {
                                !isMobile ?
                                    <div className="social-wrapper-main">
                                        <SocialShare/>
                                        <Button href={'javascript:void(0)'} onClick={handleShow} text={'Apply with Maximus'} margin={'20px 0 0'} border={'1px solid'} width={'100%'} borderColor={text} background={'transparent'} color={text} hoverBackground={hover} hoverColor={white}/>

                                    </div>
                                    :
                                    ''
                            }
                        </div>

                    </Col>

                    <Col md={{span: 8, offset: 1}} className={'details__right'} ref={detailsRef}>
                        <div className="intro border-bottom-new">
                            <div className="intro-left ">

                                {
                                    data?.data?.title &&
                                    <h1 className={'split-up'}>{reactHtmlParser(data?.data?.title)}</h1>

                                }  </div>
                        </div>

                        {
                            data?.data?.description &&
                            <div className="overview">
                                {reactHtmlParser(data?.data?.description)}
                            </div>

                        }
                        {
                            bannerImage?.full_path &&
                            <div className="banner no-border" style={{padding: 0, margin: 0, border: "none"}}>
                                <div className="banner-wrapper">
                                    <Img alt={data?.data?.title} src={bannerImage?.full_path}/>
                                </div>
                            </div>
                        }

                        {
                            sectionList.map((item, index) => {
                                switch (item?.data?.template) {
                                    case 'partner_overview':
                                        return (
                                            <div key={index} className="banner">

                                                {
                                                    item?.data?.description &&
                                                    reactHtmlParser(item?.data?.description)
                                                }
                                            </div>

                                        );
                                    case 'Table':
                                        return (
                                            <React.Fragment key={index}>
                                                {
                                                    item?.data?.description &&
                                                    reactHtmlParser(item?.data?.description)
                                                }
                                            </React.Fragment>
                                        );
                                    case 'details_list_counter':
                                        return (
                                            <React.Fragment key={index}>
                                                {
                                                    item?.data?.description &&
                                                    reactHtmlParser(item?.data?.description)
                                                }
                                            </React.Fragment>
                                        );
                                    case 'blog_description':
                                        return (
                                            <React.Fragment key={index}>
                                                {
                                                    item?.data?.description &&
                                                    reactHtmlParser(item?.data?.description)
                                                }
                                            </React.Fragment>
                                        );
                                    case 'blog_video':
                                        return (
                                            <React.Fragment key={index}>
                                                {
                                                    item?.data?.description &&
                                                    reactHtmlParser(item?.data?.description)
                                                }


                                                <VideoDetails image={item?.images?.[0]?.full_path} link={item?.data?.video_id}/>

                                                {
                                                    item?.data?.description_end &&
                                                    reactHtmlParser(item?.data?.description_end)
                                                }
                                            </React.Fragment>
                                        );
                                    case 'details_video':
                                        return (
                                            <React.Fragment key={index}>
                                                {
                                                    item?.data?.description &&
                                                    reactHtmlParser(item?.data?.description)
                                                }


                                                <VideoDetails image={item?.images?.[0]?.full_path} link={item?.data?.video_id}/>

                                                {
                                                    item?.data?.description_end &&
                                                    reactHtmlParser(item?.data?.description_end)
                                                }
                                            </React.Fragment>
                                        );
                                    case 'details_slider':
                                        return (
                                            <React.Fragment key={index}>
                                                <DetailSlider data={item}/>
                                            </React.Fragment>
                                        );
                                    default:
                                        return null; // If the template doesn't match any case, render nothing
                                }
                            })
                        }




                    </Col>

                </Row>
            </Container>
        </StyledDetails>
    );
};

const StyledDetails = styled.section`
    padding: 200px 0 200px;
    background: ${softWhite};
    position: relative;
    h6{
        margin-top: 20px;
    }
    h2{
        font-size: 1.5rem;
        line-height: 2rem;
        font-weight: 500;
        letter-spacing: -0.24px;
    }
    p{
        margin-bottom: 10px;
    }
    .nzuac-list-count , .nzuac-list{
        margin-bottom: 20px;
        margin-top: 20px;
        counter-reset: listItem 0;
        span {
            display: block;
            font-weight: 500;
        }

        li {
            position: relative;
            padding-bottom: 20px;
            margin-bottom: 20px;
            padding-left: 45px;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.16px;
            &:after{
                position: absolute;
                left: 0;
                top: 0;
                content: "";
                background: #FB5400;
                height: 24px;
                width: 24px;
                border-radius: 50%;
            
            }
            &:before{
                content: counter(listItem);
                counter-increment: listItem 1;
                position: absolute;
                left: 0;
                top: 16px;
                margin-top: -15px;
                box-sizing: content-box;
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
                color: white;
                z-index: 1;
                height: 24px;
                width: 24px;
                border-radius: 50%;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                -webkit-box-pack: center;
                justify-content: center;
            }
        }
    }
    @media (max-width: 767px) {
        padding: 80px 0 120px;
        .forMobile{
            padding: 0 !important;
        }
        .social-list-wrap-div{
            padding: 0 15px;
        }
        .mobilefooter{
            .dc-btn{
                height: 60px;
                max-width: 100% !important;
               
                a{
                    border-radius: 0 !important;
                    border: none;
                    background: ${text};

                    &:before{
                        display: none !important;
                    }
                    span{
                        color: ${white} !important;
                    }
                    
                }
            }
        }
    }

    .caption {
        font-weight: 500;
        margin-top: 20px;
    }

    .mobilefooter {
        .dc-btn {
            max-width: 270px;
        }

        .social {
            align-items: flex-start !important;
            justify-content: flex-start !important;
        }
    }

    .video-modal {
        margin-bottom: 30px;
    }

    .caption {
        margin-bottom: 60px;
    }




    .small-box-cta {
        margin-top: 20px;
    }

    //introduction

    .intro {
        margin-bottom: 30px;
        display: flex;

        &.border-bottom-new {
            border-bottom: 4px solid ${hover} !important;

        }

        .intro-left {
            flex: 0 0 80%;
            max-width: 80%;

            img {
                width: auto;
            }

            h1 {
                font-size: 32px;
                line-height: 40px;
                letter-spacing: -0.32px;
                font-weight: 500;
                color: ${text};
                margin-top: 30px;
                margin-bottom: 20px;
            }
        }

        .intro-right {
            flex: 0 0 20%;
            max-width: 20%;

            .box-wrapper {
                position: relative;
                padding-top: calc(130 / 170 * 100%);
                background: ${hover};
                height: 100%;
                border-radius: 5px;

                svg {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    opacity: 0.1;
                }

                .content {
                    position: absolute;
                    inset: 0;
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 15px;

                    p {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                        letter-spacing: -1.05px;
                        color: ${white};

                        &.ranking {
                            color: ${white};
                            font-size: 32px;
                            line-height: 40px;
                            letter-spacing: -0.32px;
                            font-weight: 500;
                        }
                    }
                }
            }
        }
    }


    //banner

    .banner {
        margin-bottom: 60px;

        .campus {
            margin-bottom: 30px;
            display: flex;
            flex-wrap: wrap;
            gap: 30px;

            .campus-single {
                flex: 0 0 calc(33.333333% - 60px);
                max-width: calc(33.333333% - 60px);
                margin-right: 30px;

                &:last-child {
                    margin-right: 0;
                }

                h5 {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    letter-spacing: -0.12px;
                    color: ${hardGray};
                    margin-bottom: 10px;
                }

                p {
                    color: ${text};
                    margin: 0;
                }
            }
        }

        .banner-wrapper {
            position: relative;
            padding-top: calc(480 / 870 * 100%);
            margin: 60px 0;

            .global-image {
                border-radius: 10px;
            }
        }
    }


    //course list

    .course-list-wrapper {
        margin-top: 30px;
        padding-bottom: 60px;
        border-bottom: 1px solid #040504;
        margin-bottom: 60px;

        h2 {
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            color: ${hover};
            margin-bottom: 30px;
        }

        .course-list {

            display: flex;
            gap: 30px;
            flex-flow: wrap;
        }

        .course-single {
            flex: 0 0 calc(33.3333% - 30px);
            max-width: calc(33.3333% - 30px);
        }
    }

    //description

    .mb-bottom {
        margin-bottom: 60px;
    }

    .overview {
        p {
            line-height: 20px;

            a {
                color: ${hover};
                text-decoration: underline;
            }
        }
    }

    p {
        line-height: 20px;

        a {
            color: ${hover};
            text-decoration: underline;
        }
    }

    .detail-description {
        .nzuac-list-count {
            margin-bottom: 20px;

            span {
                display: block;
                font-weight: 500;
            }

            li {
                &:last-child {
                    &:before {
                        display: none;
                    }
                }
            }
        }

        h2 {
            font-size: 28px;
            font-weight: 500;
            line-height: 32px;
            color: ${hover};
            margin-bottom: 20px;
        }

        table {
            gap: 20px;
            margin-bottom: 60px;

            th {
                font-size: 16px; /* 20px / 15px = 1.3333rem */
                font-weight: 400;
                line-height: 20px; /* 28px / 15px = 1.8667rem */
                color: ${text};
                border-top: none !important;
            }

            tr {
                border-bottom: 1px solid rgba(20, 38, 55, 0.2);
                justify-content: flex-start;
                padding: 20px 0;
                display: flex;
                flex-wrap: wrap;
                gap: 30px;
                font-size: 16px; /* 20px / 15px = 1.3333rem */
                font-weight: 400;
                line-height: 20px; /* 28px / 15px = 1.8667rem */

                &:first-child {
                    border-bottom: 1px solid rgba(4, 5, 4, 0.2);
                    padding-top: 0;
                }

                &:last-child {
                    border-bottom: none;
                }

                th {
                    max-width: calc(50% - 30px);
                    flex: 0 0 calc(50% - 30px);
                }

                td {
                    max-width: calc(50% - 30px);
                    flex: 0 0 calc(50% - 30px);
                }
            }
        }

        ul {
            margin-top: 0;
            margin-bottom: 60px;

            li {
                border-bottom: 1px solid rgba(4, 5, 4, 0.2);
                font-size: 16px;
                font-weight: 400;

                strong {
                    font-weight: 500;
                }
            }
        }

        a {
            color: ${hover};
            margin-bottom: 20px;
            display: inline-block;
        }

        &.mb-bottom {
            a {
                color: ${hover};
                margin-top: 20px;
                display: inline-block;
            }
        }
    }

    .image-gallery-slider {
        position: relative;
        margin-bottom: 60px;

        .navigation {
            position: absolute;
            bottom: -35px;
            right: 0;
        }

        .img-wrapper-big {
            padding-top: calc(570 / 870 * 100%);
            position: relative;
        }

        .swiper-slide-active {
            p {
                transition-delay: 0.7s;
                opacity: 1;
            }
        }

        p {
            opacity: 0;
            transition: 0.7s all cubic-bezier(0.54, 0.32, 0.05, 0.96);
            max-width: 70%;
            margin-top: 35px;
            font-weight: 500;
        }
    }

    .video-modal {
        margin: 60px 0;

        .global-image {
            border-radius: 10px;
        }
    }
   
    h2, h3, h4, h5, h6 {
        margin-bottom: 20px;


        strong {
            font-weight: 500;
            color: ${hover}
        }
    }
    .color-max {
        color: ${hover} !important;
    }
    //responsive
    @media (max-width: 992px) {
        .col-md-3 {
            display: none;
        }

        .col-md-8 {
            flex: 0 0 100%;
            max-width: 100%;
            margin: 0;
        }

        .course-list-wrapper {
            .course-single {
                max-width: calc(50% - 15px);
                flex: 0 0 calc(50% - 15px);
            }
        }
    }
    @media (max-width: 767px) {
        .intro {
            display: flex;
            align-items: flex-start;
            position: relative;

            .intro-left {
                flex: 0 0 100%;
                max-width: 100%;
            }

            .intro-right {
                flex: unset;
                max-width: unset;
                position: absolute;
                right: 0;
                top: 0;


                .box-wrapper {
                    position: unset;
                    padding-top: unset;
                    background: transparent;

                    .global-image {
                        display: none;
                    }

                    .content {
                        position: unset;
                        inset: unset;
                        padding: 0;

                        p {
                            color: #888888;

                            &.ranking {
                                color: ${hover};
                            }
                        }
                    }
                }
            }
        }

        .banner {
            .campus {
                flex-direction: column;

                .campus-single {
                    flex: 0 0 100%;
                    max-width: 100%;
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .course-list-wrapper {
            course-box {
                padding-top: calc(120 / 345 * 100%);
            }

            .course-single {
                max-width: 100%;
                flex: 0 0 100%;
            }
        }
    }
`;

export default React.memo(Details);




